(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-gift-picker"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function boot(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = '1';
      root.classList.add('vsg--noanim');

      var data = JSON.parse(root.querySelector('[data-config]').textContent);
      var info = {};
      [].forEach.call(root.querySelectorAll('.vsg__card'), function (c) {
        info[c.dataset.variantId] = { name: c.dataset.name, img: c.dataset.img, available: c.dataset.available === 'true' };
      });
      var fmt;
      try { fmt = new Intl.NumberFormat(data.locale || undefined, { style: 'currency', currency: data.currency }); } catch (e) { fmt = null; }
      function money(cents) { return fmt ? fmt.format(cents / 100) : (cents / 100).toFixed(2); }

      var busy = false;
      var attnDone = false;
      var state = { earned: 0, chosen: 0, lines: [] };
      var errEl = root.querySelector('[data-error]');

      function isGift(it) { return it.properties && it.properties._gift === 'true'; }
      function perUnit(it) {
        var n = Number(data.perUnit[it.variant_id] || 0);
        if (!n && it.properties) n = Number(it.properties._gifts_earned) || 0;
        if (!n) {
          var t = String(it.variant_title || '').toLowerCase().replace(/[\s-]/g, '');
          if (t.indexOf('3pack') > -1) n = 2; else if (t.indexOf('2pack') > -1) n = 1;
        }
        return n;
      }
      function fill(tpl, map) {
        return tpl.replace(/\{(\w+)\}/g, function (m, k) { return map[k] != null ? map[k] : m; });
      }
      root.__vsgAttn = function () {
        root.classList.remove('vsg--attn');
        void root.offsetWidth;
        root.classList.add('vsg--attn');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };
      function showError(msg) { errEl.textContent = msg || ''; }
      function reload() { window.location.reload(); }

      function trim(lines, excess) {
        var chain = Promise.resolve();
        lines.slice().reverse().forEach(function (l) {
          if (excess <= 0) return;
          var take = Math.min(l.item.quantity, excess);
          excess -= take;
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ id: l.item.key, quantity: l.item.quantity - take })
            });
          });
        });
        return chain.then(reload);
      }

      function hideGiftRows(lines) {
        if (!data.hideRows || !data.rowSelector) return;
        lines.forEach(function (l) {
          var el = document.querySelector(data.rowSelector.replace('{line}', l.line));
          if (el) el.style.display = 'none';
        });
      }

      function render(cart) {
        var earned = 0, chosen = 0, lines = [];
        cart.items.forEach(function (it, i) {
          if (isGift(it)) { chosen += it.quantity; lines.push({ item: it, line: i + 1 }); return; }
          earned += perUnit(it) * it.quantity;
        });
        state = { earned: earned, chosen: chosen, lines: lines };

        if (chosen > earned) {
          var last = 0;
          try { last = Number(sessionStorage.getItem('vsgTrim') || 0); } catch (e) {}
          if (Date.now() - last > 8000) {
            try { sessionStorage.setItem('vsgTrim', String(Date.now())); } catch (e) {}
            busy = true;
            trim(lines, chosen - earned);
            return;
          }
        }

        hideGiftRows(lines);
        root.hidden = earned <= 0;
        if (earned <= 0) return;

        var remaining = earned - chosen;
        var word = earned === 1 ? 'gift' : 'gifts';
        var ORD = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth'];
        var msg = root.querySelector('[data-msg]');
        var vars = { count: earned, gift_word: word, remaining: remaining, ordinal: ORD[chosen] || (chosen + 1) + 'th', value: money(earned * data.maxPrice) };
        var done = remaining <= 0;
        if (done) msg.textContent = fill(root.dataset.done, vars);
        else if (chosen > 0) msg.textContent = fill(root.dataset.next, vars);
        else msg.textContent = fill(earned === 1 ? root.dataset.startSingle : root.dataset.startMulti, vars);
        root.classList.toggle('vsg--done', done);
        root.querySelector('.vsg__body').setAttribute('aria-hidden', done ? 'true' : 'false');
        if (!root.__vsgShown) {
          root.__vsgShown = true;
          requestAnimationFrame(function () { requestAnimationFrame(function () { root.classList.remove('vsg--noanim'); }); });
        }

        [].forEach.call(root.querySelectorAll('.vsg__card'), function (c) {
          var btn = c.querySelector('[data-add]');
          var ok = info[c.dataset.variantId].available && remaining > 0;
          btn.disabled = !ok;
          btn.textContent = !info[c.dataset.variantId].available ? 'Sold out' : (remaining > 0 ? 'Add free gift' : 'All gifts chosen');
        });

        var list = root.querySelector('[data-list]');
        list.innerHTML = '';
        lines.forEach(function (l) {
          var meta = info[l.item.variant_id] || {};
          var li = document.createElement('li');
          li.className = 'vsg__item';
          if (meta.img || (l.item.featured_image && l.item.featured_image.url)) {
            var img = document.createElement('img');
            img.src = meta.img || l.item.featured_image.url;
            img.alt = '';
            li.appendChild(img);
          }
          var name = document.createElement('span');
          name.className = 'vsg__item-name';
          name.textContent = meta.name || l.item.product_title;
          li.appendChild(name);
          var qty = document.createElement('span');
          qty.className = 'vsg__item-qty';
          qty.textContent = '× ' + l.item.quantity;
          li.appendChild(qty);
          var free = document.createElement('span');
          free.className = 'vsg__item-free';
          free.textContent = 'FREE';
          li.appendChild(free);
          var rm = document.createElement('button');
          rm.type = 'button';
          rm.className = 'vsg__remove';
          rm.setAttribute('data-remove', l.item.key);
          rm.setAttribute('data-qty', l.item.quantity);
          rm.textContent = 'Remove';
          li.appendChild(rm);
          list.appendChild(li);
        });
        root.querySelector('[data-chosen]').hidden = lines.length === 0;

        if (!attnDone && remaining > 0 && window.location.hash === '#gifts') {
          attnDone = true;
          setTimeout(root.__vsgAttn, 200);
        }
      }

      function sync() {
        if (busy) return Promise.resolve();
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(render)
          .catch(function () {});
      }

      root.addEventListener('click', function (e) {
        var add = e.target.closest('[data-add]');
        var rm = e.target.closest('[data-remove]');
        if (!add && !rm) return;
        if (busy) return;
        showError('');

        if (add) {
          if (add.disabled || state.earned - state.chosen <= 0) return;
          var vid = Number(add.closest('.vsg__card').dataset.variantId);
          busy = true;
          add.textContent = 'Adding…';
          add.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: { _gift: 'true' } }] })
          })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add this gift.');
              reload();
            })
            .catch(function (err) { busy = false; showError(err.message); sync(); });
        } else {
          var key = rm.getAttribute('data-remove');
          var qty = Number(rm.getAttribute('data-qty'));
          busy = true;
          rm.disabled = true;
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: key, quantity: Math.max(qty - 1, 0) })
          })
            .then(function (r) { if (!r.ok) throw new Error('Could not remove this gift.'); reload(); })
            .catch(function (err) { busy = false; showError(err.message); sync(); });
        }
      });

      // Re-check whenever the theme changes the cart (quantity changes / removals on the cart page)
      if (!window.__vsgFetchPatched) {
        window.__vsgFetchPatched = true;
        var origFetch = window.fetch;
        window.fetch = function () {
          var input = arguments[0];
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var p = origFetch.apply(this, arguments);
          if (/\/cart\/(change|update|add)/.test(url)) {
            p.then(function () {
              setTimeout(function () {
                document.querySelectorAll('.vsg').forEach(function (el) { if (el.__vsgSync) el.__vsgSync(); });
              }, 400);
            }).catch(function () {});
          }
          return p;
        };
      }
      root.__vsgSync = sync;
      sync();
    }
    function boot_all() { document.querySelectorAll('.vsg').forEach(boot); }
    document.addEventListener('DOMContentLoaded', boot_all);
    document.addEventListener('shopify:section:load', boot_all);
    boot_all();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-size-stack"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.vsReady) return;
      root.dataset.vsReady = '1';
      root.addEventListener('submit', function (e) {
        var form = e.target.closest('.vsa__form');
        if (!form) return;
        e.preventDefault();
        var btn = form.querySelector('.vsa__cta');
        var msg = form.querySelector('.vsa__msg');
        var original = btn.textContent;
        btn.classList.add('is-loading');
        btn.textContent = 'ADDING…';
        msg.textContent = '';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to cart.');
            window.location.href = root.dataset.cartUrl || '/cart';
          })
          .catch(function (err) {
            btn.textContent = original;
            btn.classList.remove('is-loading');
            msg.textContent = err.message;
          });
      });
    }
    function boot() { document.querySelectorAll('.vsa').forEach(init); }
    document.addEventListener('DOMContentLoaded', boot);
    document.addEventListener('shopify:section:load', boot);
    boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
